import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import Logo from "@/components/Logo";

export default function ResetPasswordPage() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const nav = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState("");
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (password !== confirm) { setErr("Passwords don't match"); return; }
        if (!token) { setErr("Missing reset token"); return; }
        setBusy(true); setErr("");
        try {
            await api.post("/auth/reset-password", { token, password });
            setDone(true);
            setTimeout(() => nav("/login"), 2000);
        } catch (e) {
            setErr(formatApiError(e.response?.data?.detail) || e.message);
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-[var(--bg)]" data-testid="reset-password-page">
            <div className="w-full max-w-md">
                <Logo size="sm" />
                <p className="label-tiny mt-10 mb-3">/ Choose new password</p>
                <h2 className="font-serif text-5xl mb-10">Reset password</h2>

                {done ? (
                    <div className="border border-[var(--gold-deep)] bg-[var(--surface)] p-5" data-testid="reset-success">
                        <p className="text-[var(--gold-bright)] font-medium mb-2">Password updated.</p>
                        <p className="text-sm text-[var(--text-muted)]">Redirecting to sign in…</p>
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
                        <div>
                            <label className="label-tiny block mb-2">New password</label>
                            <input data-testid="reset-password-input" type="password" minLength={6} className="input-dark" value={password} onChange={(e) => setPassword(e.target.value)} required />
                        </div>
                        <div>
                            <label className="label-tiny block mb-2">Confirm password</label>
                            <input data-testid="reset-confirm-input" type="password" minLength={6} className="input-dark" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
                        </div>
                        {err && <div className="text-sm text-[var(--danger)]" data-testid="reset-error">{err}</div>}
                        <button type="submit" className="btn-primary w-full" disabled={busy} data-testid="reset-submit">
                            {busy ? "Updating…" : "Update password →"}
                        </button>
                    </form>
                )}

                <div className="gold-rule my-10" />
                <Link to="/login" className="text-sm text-[var(--text-muted)] hover:text-[var(--gold)]">← Back to sign in</Link>
            </div>
        </div>
    );
}
